/**
 * This interface describes an audio track that can contain
 * one or more audio channels. Ideally, we are using mono streams
 * so that each audio channel can be dealt with individually, for
 * instance for muting.
 */
export interface AudioTrackConfig {
  /**
   * If true, this track won't be played.
   */
  isMuted: boolean;
}

/**
 *  This object describes a range of audio peak visualization in seconds.
 */
export interface PeakRange {
  startInSeconds: number;
  endInSeconds: number;
}

/**
 *  This object is used to describe changes to a list of AudioTrackConfigs
 */
export interface AudioTrackConfigUpdate {
  trackIndex: number,
  isMuted: boolean,
}

/**
 * Track counts differ between media and can change during streaming, so updates
 * for track indices beyond the end of `configs` are ignored.
 */
export function updateAudioTrackConfig(
  configs: AudioTrackConfig[],
  updates: AudioTrackConfigUpdate[],
): AudioTrackConfig[] {
  const updatedConfigs = configs.map((c) => ({ isMuted: c.isMuted }));
  for (const { trackIndex, isMuted } of updates) {
    const config = updatedConfigs[trackIndex];
    if (config !== undefined) {
      config.isMuted = isMuted;
    }
  }
  return updatedConfigs;
}

export function createMixMatrixFromAudioTrackConfig(configs: AudioTrackConfig[]): number[][] {
  return configs.map((config, trackIndex) => {
    const row : number[] = [0.0, 0.0];
    row[trackIndex % 2] = config.isMuted ? 0.0 : 1.0;
    return row;
  });
}


